import TitleHero from '@/components/Platform/TitleHero';
import React, { useCallback, useState } from 'react';
import Image from 'next/image';
import { logCommonView } from '@/lib/service';
import { useRouter } from 'next/router';
import './index.less';

const HeroSection = ({ data, customClass }: { data: any; customClass?: string }) => {
  const router = useRouter();
  const [email, setEmail] = useState<string>('');

  const handleStart = useCallback(() => {
    if (email) {
      logCommonView(data?.input?.sourceType, email);
      router.push({ pathname: '/sell-on-pietra/register', query: { email } });
      return;
    }
    router.push({ pathname: '/sell-on-pietra/register' });
  }, [data?.input?.sourceType, email, router]);

  return (
    <div className={`hero-section-wrap ${customClass}`} style={{ ...data?.style }}>
      <TitleHero heroData={{ title: data?.title, subtitle: data?.subtitle }} />
      <div className="hero-section-action-wrap">
        <input
          type="text"
          placeholder={data?.input?.placeholder}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleStart();
            }
          }}
        />
        <button className="action-btn-container" onClick={handleStart}>
          <span>{data?.input?.btnText}</span>
        </button>
      </div>
      <div className="hero-section-content-wrap">
        {data?.content?.map((item, index) => (
          <div className="hero-section-content-item-wrap" key={`hero-section-content-item-${index}`}>
            <div className="hero-section-content-item-image">
              <Image src={item.image} fill alt={item.title} />
            </div>
            <div className="hero-section-content-item-title">{item.title}</div>
            <div className="hero-section-content-item-subtitle">{item.description}</div>
          </div>
        ))}
      </div>
      {data?.showPlatformLogo && (
        <div className="hero-section-paired-tag-wrap">
          <span>Works with proven platforms</span>
          <div className="logos-container">
            <Image width={82} height={24} src="/svg/shopify-wordmark.svg" alt="Shopify" />
            <Image width={126} height={24} src="/svg/tiktok-shop-wordmark.svg" alt="Tiktok" />
            <Image width={81} height={24} src="/svg/amazon-wordmark.svg" alt="Amazon" />
            <Image width={63} height={24} src="/svg/wix-wordmark.svg" alt="Amazon" />
            <Image width={50} height={24} src="/svg/woo-wordmark.svg" alt="Amazon" />
            <Image width={82} height={24} src="/svg/klaviyo-wordmark.svg" alt="Amazon" />
          </div>
        </div>
      )}
    </div>
  );
};
export default HeroSection;
